import React, { Component } from 'react';
import {
    quickbooksIsConnected,
    quickbooksSyncStatus,
    quickbooksSync,
    getTempToken,
    quickbooksLogout,
    quickbookSynClear
} from '../../../../appRedux/actions/QuickbookAction';
import { getSyncStatus } from '../../../../appRedux/services/QuickbookService';
import {
    companyDetail, getCompnay,companyStatus
} from '../../../../appRedux/actions/companiesAction';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';
import "react-toastify/dist/ReactToastify.css";
import "./style.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Switch from '@material-ui/core/Switch';
import { toast } from 'react-toastify';
import CircularProgress from "../../../../components/CircularProgress";

function displayValue(value) {
    if (value === null || value === undefined || value === '') {
        return '—';
    }
    return value;
}

function getQuickbooksCompanyId() {
    try {
        const user = JSON.parse(localStorage.getItem('userData'));
        if (!user) {
            return null;
        }
        const companyId = parseInt(user.companyId, 10);
        // Navbar "no company selected" uses companyId 1; that id is not a real company.
        if (isNaN(companyId) || companyId <= 1) {
            return null;
        }
        return companyId;
    } catch (e) {
        return null;
    }
}

class QuickBookPage extends Component {
    constructor(props) {
        super(props);
        var sDate = new Date(2019, 0, 1);
        var eDate = moment(new Date()).endOf('month').toDate();
        this.state = {
            StartDate: sDate,
            EndDate: eDate,
            AccountingMethod: '',
            isSyncing: false,
            syncLedgers: false,
            syncAccounts: false,
            syncVendors: false,
            syncClass: false,
            syncBill: false,
            syncDeposits: false,
            syncPayment: false,
            SyncCustomers: false,
            SyncCompanyInfo: false,
            SaveJsonInFile: false,
            SyncPurchase: false,
            SyncJournalEntry: false,
            syncInvoices: false,
            SyncTrialBalance: false,
            SyncEmployee: false,
            selectAll: false,
            doSync: false,
            grantURl: "",
            CompanyInfo: null,
            AllowEmployee: false,
            connectAndSync:false,
            loading: true
        };
        this.sync = this.sync.bind(this);
        // checking new branch commit
        this.handleFormChange = this.handleFormChange.bind(this);
    }

    componentDidMount() {
        var previousCompanyId = localStorage.getItem("connedtedCompanyId");
        if (previousCompanyId != null && previousCompanyId != "") {
            clearInterval(parseInt(previousCompanyId));
        }
        const companyId = getQuickbooksCompanyId();
        if (!companyId) {
            this.setState({ loading: false });
            return;
        }
        this.props.quickbooksIsConnected(companyId);
        this.props.getTempToken(companyId);
        this.props.getCompnay(companyId);
        this._isConnectedIntervalId = setInterval(function () {
            this.props.quickbooksIsConnected(companyId);
        }.bind(this), 10000);
        localStorage.setItem("connedtedCompanyId", this._isConnectedIntervalId);
        this.checkServerSync(companyId);
    }
    componentWillUnmount() {
        this._unmounted = true;
        clearInterval(this._isConnectedIntervalId);
        clearInterval(this._syncStatusInvervalId);
        clearTimeout(this._serverSyncTimeoutId);
        this.props.quickbookSynClear();
    }

    // Keeps the sync buttons disabled while any sync for this company runs on the server,
    // including one started before this page was opened (leaving and coming back must not allow a second sync).
    checkServerSync = (companyId) => {
        getSyncStatus(companyId).then((response) => {
            if (this._unmounted) {
                return;
            }
            const status = response.data && response.data.returnObject;
            if (status && status.isSyncing) {
                this.setState({ isSyncing: true });
                // Server sync still running: check again in 10 seconds.
                this._serverSyncTimeoutId = setTimeout(() => this.checkServerSync(companyId), 10000);
            } else if (this._serverSyncTimeoutId) {
                this._serverSyncTimeoutId = null;
                this.setState({ isSyncing: false });
                this.props.companyDetail();
            }
        }).catch(() => { });
    }

    componentWillReceiveProps(nextProps) {
        var self = this;

        try {
            if (!nextProps.isConnected && nextProps.tempToken == '') {
                const companyId = getQuickbooksCompanyId();
                if (companyId) {
                    this.props.getTempToken(companyId);
                }
            }
            else if (!nextProps.isConnected && nextProps.tempToken != '') {//&& this.props.tempToken != nextProps.tempToken
                if (!window.document.getElementById('intuit-ipp-anywhere')) {
                    var script = window.document.createElement("script");
                    script.id = 'intuit-ipp-anywhere';
                    script.type = "text/javascript";
                    script.src = "https://js.appcenter.intuit.com/Content/IA/intuit.ipp.anywhere.js";
                    window.document.body.appendChild(script);
                }

                var tempToken = nextProps.tempToken;
                // this.setState({grantURl:nextProps.tempToken});
                // var intervalId = setInterval(function () {
                //     if (!window.intuit) return;
                //     window.intuit.ipp.anywhere.setup({
                //         //grantUrl: 'http:' + window.location.href.substring(5, window.location.href.indexOf('#')) + 'API/quickbooks/OAuth/Grant?temp-auth-token=' + encodeURIComponent(tempToken)

                //         grantUrl: nextProps.tempToken

                //     });
                //     self.props.companyDetail();
                //     clearInterval(intervalId);
                // }, 50);
                this.setState({
                    grantURl: nextProps.tempToken,
                    syncLedgers: false,
                    syncAccounts: false,
                    syncVendors: false,
                    syncClass: false,
                    syncBill: false,
                    syncDeposits: false,
                    syncPayment: false,
                    SyncCustomers: false,
                    SyncCompanyInfo: false,
                    SaveJsonInFile: false,
                    SyncPurchase: false,
                    SyncJournalEntry: false,
                    syncInvoices: false,
                    SyncTrialBalance: false
                });
                const companyId = getQuickbooksCompanyId();
                // this.state.doSync = true;
                if (this._isConnectedIntervalId) {
                    clearInterval(this._isConnectedIntervalId)
                }
                if (companyId) {
                    this._isConnectedIntervalId = setInterval(function () {
                        this.props.quickbooksIsConnected(companyId);
                    }.bind(this), 10000);
                }
            }
            if (nextProps.syncMessages !== this.props.syncMessages) {
                if (nextProps.syncMessages.Status === "Completed") {
                    this.props.companyDetail();
                    clearInterval(this._syncStatusInvervalId);
                    this.setState({ isSyncing: false });
                }
            }
            if (nextProps.isConnected === true) {
                this.props.companyDetail();
                // clearInterval(this._isConnectedIntervalId);
                if (this.state.connectAndSync === true) {

                    this.syncAll();
                }
                this.state.doSync = false;
                this.state.connectAndSync = false;
            }
            if (nextProps.companies !== this.props.companies) {
                this.setState({ companiesData: nextProps.companies });
            }
            if (nextProps.company !== this.props.company) {
                var allowEmp = false;
                if (nextProps.company.payrollSoftware != null && nextProps.company.payrollSoftware.toLowerCase().indexOf("quickbook") > -1) {
                    allowEmp = true;
                }

                let sDate = this.state.StartDate;
                let eDate = this.state.EndDate;

                if (nextProps.company.quickbooksDataSyncBeginningYear) {
                    sDate = new Date(nextProps.company.quickbooksDataSyncBeginningYear, 0, 1);
                }

                if (nextProps.company.quickbooksDataSyncEndingYear) {
                    const potentialEnd = new Date(nextProps.company.quickbooksDataSyncEndingYear, 11, 31);
                    eDate = potentialEnd < eDate ? potentialEnd : eDate;
                }

                this.setState(prevState => {
                    const alreadyLoaded = prevState.CompanyInfo && prevState.CompanyInfo.companyId != null;
                    return {
                        loading: false,
                        CompanyInfo: {
                            ...nextProps.company,
                            isActive: alreadyLoaded ? prevState.CompanyInfo.isActive : nextProps.company.isActive
                        },
                        AllowEmployee: allowEmp,
                        StartDate: sDate,
                        EndDate: eDate
                    };
                });
            }
            if (nextProps.reload) {
                this.setState({ loading: false }, () => {
                    this.props.companyDetail();
                });
            };
        }
        catch (err) {

        }
    }
    accountStatusChange = (event) => {
        if (this.state.isSyncing) {
            return;
        }
        let isChecked = event.target.checked;
        this.setState(prevState => ({
            CompanyInfo: {
                ...prevState.CompanyInfo,
                isActive: isChecked
            }
        }), () => {
            let data = {
                "companyId": this.state.CompanyInfo.companyId,
                "status": isChecked
            };
            this.props.companyStatus(data)

        }

        );


    }

    handleFormChange = (e, target) => {
        if (!target) {
            this.setState({ [e.target.name]: e.target.value })
        }
        else if (target == "StartDate") {
            this.setState({ StartDate: new Date(e) });
        }
        else if (target == "EndDate") {
            this.setState({ EndDate: new Date(e) });
        }
    }

    handleFormCheched = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    disconnect = (e) => {

        var self = this;
        const user = JSON.parse(localStorage.getItem('userData'));
        self.props.quickbooksLogout(user.companyId);
    };
    syncAll() {
        var self = this;
        const user = JSON.parse(localStorage.getItem('userData'));
        var sync = {
            CompanyId: user.companyId,
            StartDate: moment(self.state.StartDate).format('YYYY-MM-DD'),
            EndDate: moment(self.state.EndDate).format('YYYY-MM-DD'),
            AccountingMethod: self.state.AccountingMethod,
            syncLedgers: true,
            syncAccounts: true,
            syncVendors: true,
            syncClass: true,
            syncInvoices: false,
            syncBill: false,
            syncDeposits: false,
            syncPayment: false,
            SyncCustomers: true,
            SyncCompanyInfo: true,
            SaveJsonInFile: true,
            SyncPurchase: false,
            SyncJournalEntry: false,
            SyncTrialBalance: true,
            SyncEmployee: this.state.AllowEmployee
        }

        this.props.quickbooksSync(sync);
        this._syncStatusInvervalId = setInterval(function () {
            this.props.quickbooksSyncStatus();
        }.bind(this), 10000);
        this.setState({ isSyncing: true });
    }

    validateAndSync = () => {
        const checkboxKeys = [
            'syncLedgers', 'syncAccounts', 'syncVendors', 'syncClass', 'syncInvoices',
            'syncBill', 'syncDeposits', 'syncPayment', 'SyncCustomers', 'SyncCompanyInfo',
            'SaveJsonInFile', 'SyncPurchase', 'SyncJournalEntry', 'SyncTrialBalance', 'SyncEmployee'
        ];
    
        const isAnyCheckboxChecked = checkboxKeys.some(key => this.state[key]);
    
        if (!isAnyCheckboxChecked) {
            toast.error('Please select at least one option to proceed with syncing.');
            return;
        }
    
        this.sync();
    };
    sync() {
        var self = this;
        const user = JSON.parse(localStorage.getItem('userData'));
        var sync = {
            CompanyId: user.companyId,
            StartDate: moment(self.state.StartDate).format('YYYY-MM-DD'),
            EndDate: moment(self.state.EndDate).format('YYYY-MM-DD'),
            AccountingMethod: self.state.AccountingMethod,
            syncLedgers: self.state.syncLedgers,
            syncAccounts: self.state.syncAccounts,
            syncVendors: self.state.syncVendors,
            syncClass: self.state.syncClass,
            syncInvoices: self.state.syncInvoices,
            syncBill: self.state.syncBill,
            syncDeposits: self.state.syncDeposits,
            syncPayment: self.state.syncPayment,
            SyncCustomers: self.state.SyncCustomers,
            SyncCompanyInfo: self.state.SyncCompanyInfo,
            SaveJsonInFile: false,
            SyncPurchase: self.state.SyncPurchase,
            SyncJournalEntry: self.state.SyncJournalEntry,
            SyncTrialBalance: false,
            SyncEmployee: this.state.AllowEmployee ? self.state.SyncEmployee : false
        }
        this.props.quickbooksSync(sync);
        this._syncStatusInvervalId = setInterval(function () {
            this.props.quickbooksSyncStatus();
        }.bind(this), 10000);
        this.setState({ isSyncing: true });
    }

    openConnection = (e) => {
        e.preventDefault();
        this.setState({ connectAndSync: true });
        window.open(this.state.grantURl, 'targetWindow',
            `toolbar=no,
        location=no,
        status=no,
        menubar=no,
        scrollbars=yes,
        resizable=yes,
        width=600px,
        height=550px`)
    }
    render() {
        var self = this;
        const isActive = this.state.CompanyInfo ? this.state.CompanyInfo.isActive : false;
        const logMessages = this.props.syncMessages.Messages || [];
        const showLog = !this.state.isSyncing && logMessages.length > 0;

        return (
            <div className="quickbook-page">
                {this.state.loading ? (
                    <div className="quickbook-loader">
                        <CircularProgress />
                    </div>
                ) : (
                <React.Fragment>
                <div className="quickbook-header">
                    <h2 className="quickbook-title">QuickBooks Data Sync</h2>
                </div>
                <div className={this.props.isConnected ? `quickbook-grid${showLog ? ' quickbook-grid--with-log' : ''}` : 'quickbook-grid quickbook-grid--single'}>
                    <div className="quickbook-col quickbook-col-form">
                        <div className="quickbook-card">
                            <h3 className="quickbook-card-title">Connection</h3>
                            <div className="quickbook-row">
                                <span className="quickbook-label">Active Status</span>
                                <span className="quickbook-value quickbook-status">
                                    <Switch
                                        color="default"
                                        checked={isActive}
                                        disabled={this.state.isSyncing}
                                        onChange={(e) => this.accountStatusChange(e)} />
                                    <span className={isActive ? 'quickbook-status-text is-active' : 'quickbook-status-text is-inactive'}>
                                        {isActive ? 'Active' : 'Inactive'}
                                    </span>
                                </span>
                            </div>
                            {this.props.isConnected
                                ? (
                                    <div className="quickbook-row">
                                        <span className="quickbook-label">Connection</span>
                                        <span className="quickbook-value quickbook-status-text is-connected">You are Connected</span>
                                    </div>
                                )
                                : (
                                    <a href="#" className="quickbook-connect" onClick={(e) => this.openConnection(e)}>
                                        <img src="/vendors/C2QB_green_btn_tall_hover.png" title="connect" alt="connect" />
                                    </a>
                                )}
                        </div>
                        {this.props.isConnected ? (
                            <div className="quickbook-card">
                                <h3 className="quickbook-card-title">Company</h3>
                                <div className="quickbook-row">
                                    <span className="quickbook-label">QB Company Id</span>
                                    <span className="quickbook-value">{displayValue(this.state.CompanyInfo ? this.state.CompanyInfo.realmID : '')}</span>
                                </div>
                                <div className="quickbook-row">
                                    <span className="quickbook-label">QB Company Name</span>
                                    <span className="quickbook-value">{displayValue(this.state.CompanyInfo ? this.state.CompanyInfo.name : '')}</span>
                                </div>
                            </div>
                        ) : null}
                        {this.props.isConnected ? (
                                <div className="quickbook-card">
                                    <h3 className="quickbook-card-title">General Ledger Custom Dates (Optional)</h3>
                                    <div className="quickbook-date-grid">
                                        <div className="quickbook-field">
                                            <span className="quickbook-label">Start Date</span>
                                            <DatePicker
                                                selected={this.state.StartDate}
                                                onChange={(e) => this.handleFormChange(e, 'StartDate')}
                                                label="Start Date"
                                                id="date"
                                                name="StartDate"
                                                margin="normal"
                                                fullWidth
                                                showMonthDropdown
                                                showYearDropdown
                                                yearDropdownItemNumber={5}
                                            />
                                        </div>
                                        <div className="quickbook-field">
                                            <span className="quickbook-label">End Date</span>
                                            <DatePicker
                                                selected={this.state.EndDate}
                                                onChange={(e) => this.handleFormChange(e, 'EndDate')}
                                                label="End Date"
                                                id="date"
                                                name="EndDate"
                                                margin="normal"
                                                fullWidth
                                                showMonthDropdown
                                                showYearDropdown
                                                yearDropdownItemNumber={5}
                                            />
                                        </div>
                                    </div>
                                    <div className="quickbook-field">
                                        <span className="quickbook-label">Accounting Method</span>
                                        <Select
                                            name="AccountingMethod"
                                            native
                                            required={true}
                                            label={"Accounting Method"}
                                            fullWidth
                                            className="quickbook-select"
                                            onChange={this.handleFormChange}
                                        >
                                            {/* <option value={'Cash'}>Cash</option> */}
                                            <option value={'Accrual'}>Accrual</option>
                                        </Select>
                                    </div>
                                </div>
                        ) : null}
                    </div>
                    {this.props.isConnected ? (
                    <div className="quickbook-col quickbook-col-options">
                                <div className="quickbook-card">
                                    <div className="quickbook-card-title-row">
                                        <h3 className="quickbook-card-title">Sync Options</h3>
                                        <label className="quickbook-select-all">
                                            <Checkbox
                                                name="SelectAll"
                                                value="SelectAll"
                                                checked={this.state.selectAll}
                                                onChange={(e) => {
                                                    this.setState({
                                                        syncLedgers: e.target.checked,
                                                        syncAccounts: e.target.checked,
                                                        syncVendors: e.target.checked,
                                                        syncClass: e.target.checked,
                                                        syncBill: e.target.checked,
                                                        syncDeposits: e.target.checked,
                                                        syncPayment: e.target.checked,
                                                        SyncCustomers: e.target.checked,
                                                        SyncCompanyInfo: e.target.checked,
                                                        SaveJsonInFile: e.target.checked,
                                                        SyncPurchase: e.target.checked,
                                                        SyncJournalEntry: e.target.checked,
                                                        syncInvoices: e.target.checked,
                                                        SyncTrialBalance: e.target.checked,
                                                        SyncEmployee: e.target.checked,
                                                        selectAll: e.target.checked
                                                    });
                                                }}
                                            />
                                            Select All
                                        </label>
                                    </div>
                                    <div className="quickbook-option-grid">
                                        <label className="quickbook-option">
                                            <Checkbox
                                                name="syncAccounts"
                                                value="syncAccounts"
                                                checked={this.state.syncAccounts}
                                                onChange={this.handleFormCheched('syncAccounts')}
                                            />
                                            Accounts
                                        </label>
                                        <label className="quickbook-option">
                                            <Checkbox
                                                name="syncLedgers"
                                                value="syncLedgers"
                                                checked={this.state.syncLedgers}
                                                onChange={this.handleFormCheched('syncLedgers')}
                                            />
                                            General Ledger
                                        </label>
                                        <label className="quickbook-option">
                                            <Checkbox
                                                name="syncVendors"
                                                value="syncVendors"
                                                checked={this.state.syncVendors}
                                                onChange={this.handleFormCheched('syncVendors')}
                                            />
                                            Vendors
                                        </label>
                                        {/* <Grid item sm={4}>
                                <Checkbox
                                    name="syncBill"
                                    value={this.state.syncBill}
                                    checked={this.state.syncBill}
                                    onChange={this.handleFormCheched('syncBill')}
                                />
                                <label>Bill</label>
                            </Grid> */}
                                        {/* <Grid item sm={4}>
                                <Checkbox
                                    name="syncDeposits"
                                    value={this.state.syncDeposits}
                                    checked={this.state.syncDeposits}
                                    onChange={this.handleFormCheched('syncDeposits')}
                                />
                                <label>Deposits</label>
                            </Grid> */}
                                        {/* <Grid item sm={4}>
                                <Checkbox
                                    name="syncInvoices"
                                    value={this.state.syncInvoices}
                                    checked={this.state.syncInvoices}
                                    onChange={this.handleFormCheched('syncInvoices')}
                                />
                                <label>Invoices</label>
                            </Grid> */}
                                        {/* <Grid item sm={4}>
                                <Checkbox
                                    name="syncPayment"
                                    value={this.state.syncPayment}
                                    checked={this.state.syncPayment}
                                    onChange={this.handleFormCheched('syncPayment')}
                                />
                                <label>Payments</label>
                            </Grid> */}
                                        {/* <Grid item sm={4}>
                                <Checkbox
                                    name="SyncPurchase"
                                    value={this.state.SyncPurchase}
                                    checked={this.state.SyncPurchase}
                                    onChange={this.handleFormCheched('SyncPurchase')}
                                />
                                <label>Purchase</label>
                            </Grid>
                            <Grid item sm={4}>
                                <Checkbox
                                    name="SyncJournalEntry"
                                    value={this.state.SyncJournalEntry}
                                    checked={this.state.SyncJournalEntry}
                                    onChange={this.handleFormCheched('SyncJournalEntry')}
                                />
                                <label>Journal Entry</label>
                            </Grid> */}
                                        <label className="quickbook-option">
                                            <Checkbox
                                                name="SyncCustomers"
                                                value="SyncCustomers"
                                                checked={this.state.SyncCustomers}
                                                onChange={this.handleFormCheched('SyncCustomers')}
                                            />
                                            Customers
                                        </label>
                                        <label className="quickbook-option">
                                            <Checkbox
                                                name="SyncCompanyInfo"
                                                value="SyncCompanyInfo"
                                                checked={this.state.SyncCompanyInfo}
                                                onChange={this.handleFormCheched('SyncCompanyInfo')}
                                            />
                                            Company Info
                                        </label>
                                        <label className="quickbook-option">
                                            <Checkbox
                                                name="SaveJsonInFile"
                                                value="SaveJsonInFile"
                                                checked={this.state.SaveJsonInFile}
                                                onChange={this.handleFormCheched('SaveJsonInFile')}
                                            />
                                            Save Json InFile
                                        </label>
                                        {this.state.AllowEmployee &&
                                            <label className="quickbook-option">
                                                <Checkbox
                                                    name="SyncEmployee"
                                                    value="SyncEmployee"
                                                    checked={this.state.SyncEmployee}
                                                    onChange={this.handleFormCheched('SyncEmployee')}
                                                />
                                                Employees
                                            </label>
                                        }
                                    </div>
                                </div>
                    <div className="quickbook-actions">
                        <Button className="quickbook-btn" disabled={this.state.isSyncing}
                            onClick={this.validateAndSync} variant="contained" color="primary">{this.state.isSyncing ? 'Syncing...' : 'Sync Data'}</Button>
                        <Button className="quickbook-btn" disabled={this.state.isSyncing}
                            onClick={self.disconnect} variant="contained" color="primary">Disconnect</Button>
                    </div>
                    </div>
                    ) : null}
                    {showLog ? (
                    <div className="quickbook-col quickbook-col-log">
                            <div className="quickbook-card quickbook-log">
                                <h3 className="quickbook-card-title">Sync Log</h3>
                                <div className="quickbook-log-body">
                                <ul className="quickbook-log-list">
                                    {logMessages.map(function (sm, index) {
                                        return (
                                            <li key={index} className="quickbook-log-item">
                                                <h4 className="quickbook-log-date">{sm.Date != null ? moment(sm.Date).format('MM/DD/YYYY') : ''}</h4>
                                                <p className="quickbook-log-text">{sm.Message}</p>
                                            </li>
                                        );
                                    })}
                                </ul>
                                </div>
                            </div>
                    </div>
                    ) : null}
                </div>
                </React.Fragment>
                )}
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        isConnected: state.quickbook.isConnected,
        syncMessages: state.quickbook.syncMessages,
        tempToken: state.quickbook.tempToken,
        company: state.companyReducer.companyDeatils,
        reload: state.companyReducer.reload,
    }
}
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        quickbooksIsConnected, quickbooksSyncStatus, quickbooksSync, getTempToken, quickbooksLogout, companyDetail, quickbookSynClear,
        getCompnay,companyStatus
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(QuickBookPage)